module.exports = __webpack_public_path__ + "static/media/292x0w (3).3ce25b6f.webp";